import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { IUnitedSections, PDF } from 'constants/businessToolSections';
import { FOR_BANK_SECTIONS } from 'constants/businessToolSections/forBank';
import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';
import { ONE_PAGE_SHORT_SECTIONS } from 'constants/businessToolSections/onePageShort';

export const aiSections: Record<IUnitedSections, string[]> = {
  // FOR BANK
  [FOR_BANK_SECTIONS.OVERVIEW]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.projectBriefDescription',
    'GLOBAL.coverTitle',
    'GLOBAL.mainGoals',
    'GLOBAL.mainProductsOrServices',
    'GLOBAL.strategyForAchievingGoals',
    'GLOBAL.targetMarket',
    'GLOBAL.targetAudience',
    'GLOBAL.targetChannels',
    'GLOBAL.mainCompetitors',
    'GLOBAL.mission',
  ],
  [FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY]: [
    'GLOBAL.projectBriefDescription',
    'GLOBAL.mainGoals',
    'GLOBAL.mainProductsOrServices',
    'GLOBAL.strategyForAchievingGoals',
    'GLOBAL.targetMarket',
    'GLOBAL.targetAudience',
    'GLOBAL.targetChannels',
    'GLOBAL.mainCompetitors',
    'EXECUTIVE_SUMMARY.companyDescription.history',
    'EXECUTIVE_SUMMARY.companyDescription.resourcesAndAssets',
    'EXECUTIVE_SUMMARY.productsOrServices.productsValue',
    'GLOBAL.competitionAdvantage',
    'GLOBAL.productDevelopmentPlans',
    'EXECUTIVE_SUMMARY.marketAndCustomers.dynamics',
    'EXECUTIVE_SUMMARY.marketAndCustomers.competitionPlan',
    'EXECUTIVE_SUMMARY.risks.mainRisks',
    'EXECUTIVE_SUMMARY.risks.measures',
  ],
  [FOR_BANK_SECTIONS.ABOUT_COMPANY]: [
    'GLOBAL.companyBriefDescription',
    'ABOUT_COMPANY.companyHistory.businessIdeaConception',
    'ABOUT_COMPANY.companyHistory.motivation',
    'ABOUT_COMPANY.missionAndStrategy.visionOfFuture',
    'ABOUT_COMPANY.missionAndStrategy.coreValues',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
    // complex fields
    'ABOUT_COMPANY.swot',
    'ABOUT_COMPANY.missionAndStrategy.goals',
  ],
  [FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES]: [
    'GLOBAL.competitionAdvantage',
    'GLOBAL.productDevelopmentPlans',
    'PRODUCTS_AND_SERVICES.description.productsOrServicesAndTheirPurpose',
    'PRODUCTS_AND_SERVICES.description.qualityStandards',
    'PRODUCTS_AND_SERVICES.advantages.productValue',
    'PRODUCTS_AND_SERVICES.randd.readinessLevel',
    'PRODUCTS_AND_SERVICES.randd.conductedActivities',
    'PRODUCTS_AND_SERVICES.randd.resources',
    'PRODUCTS_AND_SERVICES.randd.weaknesses',
    'PRODUCTS_AND_SERVICES.deliveryAndSupport.logistics',
    'PRODUCTS_AND_SERVICES.deliveryAndSupport.postPurchase',
    'PRODUCTS_AND_SERVICES.deliveryAndSupport.anyWarranty',
  ],
  [FOR_BANK_SECTIONS.MARKET_ANALYSIS]: [
    'MARKET_ANALYSIS.marketOverview.mainMarketOverview',
    'MARKET_ANALYSIS.marketOverview.servicesProductsSummary',
    'MARKET_ANALYSIS.marketOverview.consumersDescription',
    'MARKET_ANALYSIS.marketOverview.marketCompetitors',
    'MARKET_ANALYSIS.marketOverview.actualAndForecastedConsumption',
    'MARKET_ANALYSIS.marketOverview.marketShare',
    'MARKET_ANALYSIS.marketOverview.salesMethod',
    'MARKET_ANALYSIS.marketOverview.marketStructureDescription',
    'MARKET_ANALYSIS.marketOverview.marketGrowthFactors',
    'MARKET_ANALYSIS.marketOverview.technologyImpact',
    'MARKET_ANALYSIS.marketOverview.priceStrategies',
    'MARKET_ANALYSIS.competitiveAnalysis.competitors',
    'MARKET_ANALYSIS.competitiveAnalysis.attractingCompetitorsCustomers',
    'MARKET_ANALYSIS.competitiveAnalysis.competitorsDifference',
    'MARKET_ANALYSIS.competitiveAnalysis.purchasingProducts',
    'MARKET_ANALYSIS.competitiveAnalysis.futureExpectations',
    'MARKET_ANALYSIS.competitiveAnalysis.barriers',
    'MARKET_ANALYSIS.competitiveAnalysis.changingOfCurrentMarket',
    'MARKET_ANALYSIS.consumerNeeds.purchasingDecision',
    'MARKET_ANALYSIS.consumerNeeds.influencingFactors',
    'MARKET_ANALYSIS.consumerNeeds.differences',
    'MARKET_ANALYSIS.consumerNeeds.howCustomersSatisfied',
    'MARKET_ANALYSIS.consumerNeeds.demand',
    'MARKET_ANALYSIS.consumerNeeds.customerBaseSize',
    'MARKET_ANALYSIS.consumerNeeds.survey',
    // complex fields
    'MARKET_ANALYSIS.marketOverview.marketTrends',
    'MARKET_ANALYSIS.competitiveAnalysis.keyCompetitors',
    'MARKET_ANALYSIS.competitiveAnalysis.competitorsQualities',
    'MARKET_ANALYSIS.consumerNeeds.B2C',
    'MARKET_ANALYSIS.consumerNeeds.B2B',
  ],
  [FOR_BANK_SECTIONS.MARKETING_AND_SALES]: [
    'MARKETING_AND_SALES.salesPlan.goals',
    'MARKETING_AND_SALES.salesPlan.affectFactors',
    'MARKETING_AND_SALES.salesPlan.performanceIndictors',
    'MARKETING_AND_SALES.salesPlan.detailedSalesChannel',
    'MARKETING_AND_SALES.salesPlan.salesTeamStructure',
    'MARKETING_AND_SALES.salesPlan.motivationSystem',
    'MARKETING_AND_SALES.marketingPlan.advertisingCampaigns',
    'MARKETING_AND_SALES.marketingPlan.budget',
    'MARKETING_AND_SALES.marketingPlan.brandElements',
    'MARKETING_AND_SALES.marketingPlan.positioning',
    'MARKETING_AND_SALES.marketingPlan.pricingStrategy',
    'MARKETING_AND_SALES.marketingPlan.toolsAndTechnologies',
    // complex fields
    'MARKETING_AND_SALES.salesPlan.stages',
    'MARKETING_AND_SALES.salesPlan.salesChannels',
    'GLOBAL.products',
  ],
  [FOR_BANK_SECTIONS.BUSINESS_OPERATIONS]: [
    'BUSINESS_OPERATIONS.locationAndPremises.location',
    'BUSINESS_OPERATIONS.locationAndPremises.qualities',
    'BUSINESS_OPERATIONS.locationAndPremises.futurePlans',
    'BUSINESS_OPERATIONS.equipment.description',
    'BUSINESS_OPERATIONS.equipment.levelOfUtilization',
    'BUSINESS_OPERATIONS.equipment.rationaleForPurchasing',
    'BUSINESS_OPERATIONS.otherAssets.description',
    'BUSINESS_OPERATIONS.otherAssets.rationaleForPurchasing',
    'BUSINESS_OPERATIONS.technologicalProcess.technology',
    'BUSINESS_OPERATIONS.technologicalProcess.qualities',
    'BUSINESS_OPERATIONS.technologicalProcess.competingTechnology',
    'BUSINESS_OPERATIONS.workingResources.necessaryRecourses',
    'BUSINESS_OPERATIONS.workingResources.availability',
    'BUSINESS_OPERATIONS.partnersSection.criteria',
    'BUSINESS_OPERATIONS.production.specifics',
    'BUSINESS_OPERATIONS.production.package',
    'BUSINESS_OPERATIONS.production.inventoryManagement',
    'BUSINESS_OPERATIONS.production.outsourcingOpportunities',
    'BUSINESS_OPERATIONS.production.involvedProduction',
    'BUSINESS_OPERATIONS.production.disposalWaist',
    'BUSINESS_OPERATIONS.quality.factors',
    'BUSINESS_OPERATIONS.quality.methods',
  ],
  [FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: [
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.history',
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.skills',
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.personalQualities',
    'MANAGEMENT_AND_ORGANIZATION.externalPartnersAndAdvisers.partners',
    'MANAGEMENT_AND_ORGANIZATION.externalPartnersAndAdvisers.criteria',
    'MANAGEMENT_AND_ORGANIZATION.externalPartnersAndAdvisers.plans',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.numberOfStaff',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.skills',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.additionalHires',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.approaches',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.attractingDifficulties',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.salaryPolicy',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.retentionDifficulties',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.developmentPrograms',
  ],
  [FOR_BANK_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: [
    'RAISING_AND_ALLOCATING_FUNDS.investmentTotalCost',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDirectionDetails',
    'RAISING_AND_ALLOCATING_FUNDS.expectedFundingPeriod',
    'RAISING_AND_ALLOCATING_FUNDS.financedPortionDescription',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.borrowDescription',
    'RAISING_AND_ALLOCATING_FUNDS.loanTerms',
    'RAISING_AND_ALLOCATING_FUNDS.raisingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.terms',
    'RAISING_AND_ALLOCATING_FUNDS.actionsInSearchingForFunding',
    'RAISING_AND_ALLOCATING_FUNDS.attractingFinancingExperience',
    'RAISING_AND_ALLOCATING_FUNDS.utilizingSupportPrograms',
  ],
  [FOR_BANK_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS]: [
    'LEGAL_FRAMEWORKS_AND_RISKS.generalLaws',
    'LEGAL_FRAMEWORKS_AND_RISKS.industryRequirements',
    'LEGAL_FRAMEWORKS_AND_RISKS.legalRequirements',
    // complex fields
    'LEGAL_FRAMEWORKS_AND_RISKS.listOfRisks',
  ],
  [FOR_BANK_SECTIONS.IMPLEMENTATION_PLAN]: [],
  [FOR_BANK_SECTIONS.FINANCIAL_PLAN]: [
    'FINANCIAL_PLAN.keyAssumptions.expectedRevenueVolume',
    'FINANCIAL_PLAN.keyAssumptions.increaseFactors',
    'FINANCIAL_PLAN.keyAssumptions.changeInPrices',
    'FINANCIAL_PLAN.keyAssumptions.seasonalityAndEconomicCyclesAffection',
    'FINANCIAL_PLAN.keyAssumptions.costFormation',
    'FINANCIAL_PLAN.keyAssumptions.expenses',
    'FINANCIAL_PLAN.keyAssumptions.costsInfluenceFactors',
    'FINANCIAL_PLAN.keyAssumptions.costEstimation',
    'FINANCIAL_PLAN.keyAssumptions.logisticsAffect',
    'FINANCIAL_PLAN.keyAssumptions.fixedCostsDistributing',
    'FINANCIAL_PLAN.keyAssumptions.researchMainComponents',
    'FINANCIAL_PLAN.keyAssumptions.highestPriorityProjects',
    'FINANCIAL_PLAN.keyAssumptions.mainCostComponents',
    'FINANCIAL_PLAN.keyAssumptions.generalStructure',
    'FINANCIAL_PLAN.keyAssumptions.otherOperatingExpenses',
    'FINANCIAL_PLAN.keyAssumptions.controlStrategies',
    'FINANCIAL_PLAN.keyAssumptions.fixedExpensesTypes',
    'FINANCIAL_PLAN.keyAssumptions.financialExpensesAmount',
    'FINANCIAL_PLAN.keyAssumptions.nonOperatingExpenses',
    'FINANCIAL_PLAN.keyAssumptions.typesOfTaxes',
    // complex fields
    'GLOBAL.products',
    'FINANCIAL_PLAN.plannedExpenses.monthlyExpenses',
  ],
  // FOR INVESTORS
  [FOR_INVESTORS_SECTIONS.OVERVIEW]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.mainGoals',
    'GLOBAL.projectBriefDescription',
    'GLOBAL.coverTitle',
    'GLOBAL.mainProductsOrServices',
    'GLOBAL.strategyForAchievingGoals',
    'GLOBAL.targetMarket',
    'GLOBAL.targetAudience',
    'GLOBAL.targetChannels',
    'GLOBAL.mainCompetitors',
  ],
  [FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY]: [
    'GLOBAL.mainGoals',
    'GLOBAL.projectBriefDescription',
    'GLOBAL.strategyForAchievingGoals',
    'GLOBAL.mission',
    'EXECUTIVE_SUMMARY.companyDescription.history',
    'EXECUTIVE_SUMMARY.companyDescription.resourcesAndAssets',
    'GLOBAL.mainProductsOrServices',
    'EXECUTIVE_SUMMARY.productsOrServices.productsValue',
    'GLOBAL.competitionAdvantage',
    'GLOBAL.productDevelopmentPlans',
    'GLOBAL.targetMarket',
    'EXECUTIVE_SUMMARY.marketAndCustomers.dynamics',
    'GLOBAL.targetAudience',
    'GLOBAL.targetChannels',
    'GLOBAL.mainCompetitors',
  ],
  [FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.projectBriefDescription',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
    // complex fields
    'ABOUT_COMPANY.missionAndStrategy.goals',
    'ABOUT_COMPANY.swot',
  ],
  [FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS]: [
    'MARKET_ANALYSIS.marketOverview.mainMarketOverview',
    'MARKET_ANALYSIS.marketOverview.servicesProductsSummary',
    'GLOBAL.targetMarket',
    'MARKET_ANALYSIS.marketOverview.salesMethod',
    'MARKET_ANALYSIS.marketOverview.marketStructureDescription',
    'MARKET_ANALYSIS.marketOverview.marketGrowthFactors',
    'MARKET_ANALYSIS.marketOverview.priceStrategies',
    'MARKET_ANALYSIS.marketOverview.actualAndForecastedConsumption',
    'MARKET_ANALYSIS.competitiveAnalysis.competitors',
    'MARKET_ANALYSIS.competitiveAnalysis.barriers',
    'MARKET_ANALYSIS.consumerNeeds.purchasingDecision',
    'MARKET_ANALYSIS.consumerNeeds.howCustomersSatisfied',
    'MARKET_ANALYSIS.consumerNeeds.demand',
    'MARKET_ANALYSIS.consumerNeeds.customerBaseSize',
    // complex fields
    'MARKET_ANALYSIS.marketOverview.marketTrends',
    'MARKET_ANALYSIS.competitiveAnalysis.keyCompetitors',
    'MARKET_ANALYSIS.competitiveAnalysis.competitorsQualities',
    'MARKET_ANALYSIS.consumerNeeds.B2C',
    'MARKET_ANALYSIS.consumerNeeds.B2B',
  ],
  [FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES]: [
    'MARKETING_AND_SALES.salesPlan.goals',
    'MARKETING_AND_SALES.salesPlan.affectFactors',
    'MARKETING_AND_SALES.salesPlan.detailedSalesChannel',
    'MARKETING_AND_SALES.marketingPlan.advertisingCampaigns',
    'MARKETING_AND_SALES.marketingPlan.positioning',
    'MARKETING_AND_SALES.marketingPlan.pricingStrategy',
    // complex fields
    'MARKETING_AND_SALES.salesPlan.salesChannels',
    'GLOBAL.products',
  ],
  [FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS]: [
    'BUSINESS_OPERATIONS.locationAndPremises.location',
    'BUSINESS_OPERATIONS.locationAndPremises.futurePlans',
    'BUSINESS_OPERATIONS.equipment.description',
    'BUSINESS_OPERATIONS.otherAssets.description',
    'BUSINESS_OPERATIONS.technologicalProcess.technology',
    'BUSINESS_OPERATIONS.workingResources.necessaryRecourses',
    'BUSINESS_OPERATIONS.production.specifics',
    'GLOBAL.mainProductsOrServices',
    'PRODUCTS_AND_SERVICES.description.qualityStandards',
    'GLOBAL.competitionAdvantage',
    'PRODUCTS_AND_SERVICES.advantages.productValue',
    'PRODUCTS_AND_SERVICES.description.productsOrServicesAndTheirPurpose',
  ],
  [FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: [
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.history',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.numberOfStaff',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.skills',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.additionalHires',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.salaryPolicy',
  ],
  [FOR_INVESTORS_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: [
    'RAISING_AND_ALLOCATING_FUNDS.investmentTotalCost',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDirectionDetails',
    'RAISING_AND_ALLOCATING_FUNDS.expectedFundingPeriod',
    'RAISING_AND_ALLOCATING_FUNDS.financedPortionDescription',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.raisingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.terms',
  ],
  [FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN]: [
    'FINANCIAL_PLAN.keyAssumptions.expectedRevenueVolume',
    'FINANCIAL_PLAN.keyAssumptions.increaseFactors',
    'FINANCIAL_PLAN.keyAssumptions.changeInPrices',
    'FINANCIAL_PLAN.keyAssumptions.seasonalityAndEconomicCyclesAffection',
    'FINANCIAL_PLAN.keyAssumptions.costFormation',
    'FINANCIAL_PLAN.keyAssumptions.expenses',
    'FINANCIAL_PLAN.keyAssumptions.costsInfluenceFactors',
    'FINANCIAL_PLAN.keyAssumptions.costEstimation',
    'FINANCIAL_PLAN.keyAssumptions.logisticsAffect',
    'FINANCIAL_PLAN.keyAssumptions.fixedCostsDistributing',
    'FINANCIAL_PLAN.keyAssumptions.researchMainComponents',
    'FINANCIAL_PLAN.keyAssumptions.highestPriorityProjects',
    'FINANCIAL_PLAN.keyAssumptions.mainCostComponents',
    'FINANCIAL_PLAN.keyAssumptions.generalStructure',
    'FINANCIAL_PLAN.keyAssumptions.otherOperatingExpenses',
    'FINANCIAL_PLAN.keyAssumptions.controlStrategies',
    'FINANCIAL_PLAN.keyAssumptions.fixedExpensesTypes',
    'FINANCIAL_PLAN.keyAssumptions.financialExpensesAmount',
    'FINANCIAL_PLAN.keyAssumptions.nonOperatingExpenses',
    'FINANCIAL_PLAN.keyAssumptions.typesOfTaxes',

    // complex fields
    'GLOBAL.products',
    'FINANCIAL_PLAN.plannedExpenses.monthlyExpenses',
  ],
  // ONE PAGE SHORT
  [ONE_PAGE_SHORT_SECTIONS.SHORT]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.projectBriefDescription',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
    'GLOBAL.targetMarket',
    'GLOBAL.mainCompetitors',
    'GLOBAL.revenueStreams',
    'GLOBAL.marketingStrategy',
  ],
  // ONE PAGE
  [ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY]: ['GLOBAL.companyBriefDescription'],
  [ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT]: [
    'GLOBAL.mainGoals',
    'GLOBAL.projectBriefDescription',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
  ],
  [ONE_PAGE_SECTIONS.PRODUCTS_SERVICES]: ['GLOBAL.mainProductsOrServices', 'GLOBAL.competitionAdvantage'],
  [ONE_PAGE_SECTIONS.MARKET_AND_SALES]: [
    'GLOBAL.targetMarket',
    'EXECUTIVE_SUMMARY.marketAndCustomers.dynamics',
    'GLOBAL.mainCompetitors',
    'GLOBAL.targetAudience',
    'GLOBAL.revenueStreams',
    'GLOBAL.marketingStrategy',
    'GLOBAL.targetChannels',
  ],
  [ONE_PAGE_SECTIONS.TEAM]: ['EXECUTIVE_SUMMARY.organizationAndTeam.members'],
  [ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS]: [],
  [ONE_PAGE_SECTIONS.FINANCING_NEEDS]: [],
  [ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN]: [],
  // PDF for typescript
  [PDF.TITLE_PAGE_AND_TABLE_OF_CONTENTS]: [],
};

export const aiAllDocumentFields = {
  [BUSINESS_PLAN_TYPES.FOR_BANK]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.projectBriefDescription',
    'GLOBAL.coverTitle',
    'GLOBAL.mainGoals',
    'GLOBAL.mainProductsOrServices',
    'GLOBAL.strategyForAchievingGoals',
    'GLOBAL.targetMarket',
    'GLOBAL.targetAudience',
    'GLOBAL.targetChannels',
    'GLOBAL.mainCompetitors',
    'GLOBAL.mission',
    'EXECUTIVE_SUMMARY.companyDescription.history',
    'EXECUTIVE_SUMMARY.companyDescription.resourcesAndAssets',
    'EXECUTIVE_SUMMARY.productsOrServices.productsValue',
    'GLOBAL.competitionAdvantage',
    'GLOBAL.productDevelopmentPlans',
    'EXECUTIVE_SUMMARY.marketAndCustomers.dynamics',
    'EXECUTIVE_SUMMARY.marketAndCustomers.competitionPlan',
    'EXECUTIVE_SUMMARY.risks.mainRisks',
    'EXECUTIVE_SUMMARY.risks.measures',
    'ABOUT_COMPANY.companyHistory.businessIdeaConception',
    'ABOUT_COMPANY.companyHistory.motivation',
    'ABOUT_COMPANY.missionAndStrategy.visionOfFuture',
    'ABOUT_COMPANY.missionAndStrategy.coreValues',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
    'PRODUCTS_AND_SERVICES.description.productsOrServicesAndTheirPurpose',
    'PRODUCTS_AND_SERVICES.description.qualityStandards',
    'PRODUCTS_AND_SERVICES.advantages.productValue',
    'PRODUCTS_AND_SERVICES.randd.readinessLevel',
    'PRODUCTS_AND_SERVICES.randd.conductedActivities',
    'PRODUCTS_AND_SERVICES.randd.resources',
    'PRODUCTS_AND_SERVICES.randd.weaknesses',
    'PRODUCTS_AND_SERVICES.deliveryAndSupport.logistics',
    'PRODUCTS_AND_SERVICES.deliveryAndSupport.postPurchase',
    'PRODUCTS_AND_SERVICES.deliveryAndSupport.anyWarranty',
    'MARKET_ANALYSIS.marketOverview.mainMarketOverview',
    'MARKET_ANALYSIS.marketOverview.servicesProductsSummary',
    'MARKET_ANALYSIS.marketOverview.consumersDescription',
    'MARKET_ANALYSIS.marketOverview.marketCompetitors',
    'MARKET_ANALYSIS.marketOverview.actualAndForecastedConsumption',
    'MARKET_ANALYSIS.marketOverview.marketShare',
    'MARKET_ANALYSIS.marketOverview.salesMethod',
    'MARKET_ANALYSIS.marketOverview.marketStructureDescription',
    'MARKET_ANALYSIS.marketOverview.marketGrowthFactors',
    'MARKET_ANALYSIS.marketOverview.technologyImpact',
    'MARKET_ANALYSIS.marketOverview.priceStrategies',
    'MARKET_ANALYSIS.competitiveAnalysis.competitors',
    'MARKET_ANALYSIS.competitiveAnalysis.attractingCompetitorsCustomers',
    'MARKET_ANALYSIS.competitiveAnalysis.competitorsDifference',
    'MARKET_ANALYSIS.competitiveAnalysis.purchasingProducts',
    'MARKET_ANALYSIS.competitiveAnalysis.futureExpectations',
    'MARKET_ANALYSIS.competitiveAnalysis.barriers',
    'MARKET_ANALYSIS.competitiveAnalysis.changingOfCurrentMarket',
    'MARKET_ANALYSIS.consumerNeeds.purchasingDecision',
    'MARKET_ANALYSIS.consumerNeeds.influencingFactors',
    'MARKET_ANALYSIS.consumerNeeds.differences',
    'MARKET_ANALYSIS.consumerNeeds.howCustomersSatisfied',
    'MARKET_ANALYSIS.consumerNeeds.demand',
    'MARKET_ANALYSIS.consumerNeeds.customerBaseSize',
    'MARKET_ANALYSIS.consumerNeeds.survey',
    'MARKETING_AND_SALES.salesPlan.goals',
    'MARKETING_AND_SALES.salesPlan.affectFactors',
    'MARKETING_AND_SALES.salesPlan.performanceIndictors',
    'MARKETING_AND_SALES.salesPlan.detailedSalesChannel',
    'MARKETING_AND_SALES.salesPlan.salesTeamStructure',
    'MARKETING_AND_SALES.salesPlan.motivationSystem',
    'MARKETING_AND_SALES.marketingPlan.advertisingCampaigns',
    'MARKETING_AND_SALES.marketingPlan.budget',
    'MARKETING_AND_SALES.marketingPlan.brandElements',
    'MARKETING_AND_SALES.marketingPlan.positioning',
    'MARKETING_AND_SALES.marketingPlan.pricingStrategy',
    'MARKETING_AND_SALES.marketingPlan.toolsAndTechnologies',
    'BUSINESS_OPERATIONS.locationAndPremises.location',
    'BUSINESS_OPERATIONS.locationAndPremises.qualities',
    'BUSINESS_OPERATIONS.locationAndPremises.futurePlans',
    'BUSINESS_OPERATIONS.equipment.description',
    'BUSINESS_OPERATIONS.equipment.levelOfUtilization',
    'BUSINESS_OPERATIONS.equipment.rationaleForPurchasing',
    'BUSINESS_OPERATIONS.otherAssets.description',
    'BUSINESS_OPERATIONS.otherAssets.rationaleForPurchasing',
    'BUSINESS_OPERATIONS.technologicalProcess.technology',
    'BUSINESS_OPERATIONS.technologicalProcess.qualities',
    'BUSINESS_OPERATIONS.technologicalProcess.competingTechnology',
    'BUSINESS_OPERATIONS.workingResources.necessaryRecourses',
    'BUSINESS_OPERATIONS.workingResources.availability',
    'BUSINESS_OPERATIONS.partnersSection.criteria',
    'BUSINESS_OPERATIONS.production.specifics',
    'BUSINESS_OPERATIONS.production.package',
    'BUSINESS_OPERATIONS.production.inventoryManagement',
    'BUSINESS_OPERATIONS.production.outsourcingOpportunities',
    'BUSINESS_OPERATIONS.production.involvedProduction',
    'BUSINESS_OPERATIONS.production.disposalWaist',
    'BUSINESS_OPERATIONS.quality.factors',
    'BUSINESS_OPERATIONS.quality.methods',
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.history',
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.skills',
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.personalQualities',
    'MANAGEMENT_AND_ORGANIZATION.externalPartnersAndAdvisers.partners',
    'MANAGEMENT_AND_ORGANIZATION.externalPartnersAndAdvisers.criteria',
    'MANAGEMENT_AND_ORGANIZATION.externalPartnersAndAdvisers.plans',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.numberOfStaff',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.skills',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.additionalHires',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.approaches',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.attractingDifficulties',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.salaryPolicy',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.retentionDifficulties',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.developmentPrograms',
    'RAISING_AND_ALLOCATING_FUNDS.investmentTotalCost',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDirectionDetails',
    'RAISING_AND_ALLOCATING_FUNDS.expectedFundingPeriod',
    'RAISING_AND_ALLOCATING_FUNDS.financedPortionDescription',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.borrowDescription',
    'RAISING_AND_ALLOCATING_FUNDS.loanTerms',
    'RAISING_AND_ALLOCATING_FUNDS.raisingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.terms',
    'RAISING_AND_ALLOCATING_FUNDS.actionsInSearchingForFunding',
    'RAISING_AND_ALLOCATING_FUNDS.attractingFinancingExperience',
    'RAISING_AND_ALLOCATING_FUNDS.utilizingSupportPrograms',
    'LEGAL_FRAMEWORKS_AND_RISKS.generalLaws',
    'LEGAL_FRAMEWORKS_AND_RISKS.industryRequirements',
    'LEGAL_FRAMEWORKS_AND_RISKS.legalRequirements',
    // complex fields
    'ABOUT_COMPANY.swot',
    'ABOUT_COMPANY.missionAndStrategy.goals',
    'MARKET_ANALYSIS.marketOverview.marketTrends',
    'MARKET_ANALYSIS.competitiveAnalysis.keyCompetitors',
    'MARKET_ANALYSIS.competitiveAnalysis.competitorsQualities',
    'MARKET_ANALYSIS.consumerNeeds.B2C',
    'MARKET_ANALYSIS.consumerNeeds.B2B',
    'MARKETING_AND_SALES.salesPlan.stages',
    'MARKETING_AND_SALES.salesPlan.salesChannels',
    'LEGAL_FRAMEWORKS_AND_RISKS.listOfRisks',
    'GLOBAL.products',
    'FINANCIAL_PLAN.plannedExpenses.monthlyExpenses',
  ],
  [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.mainGoals',
    'GLOBAL.projectBriefDescription',
    'GLOBAL.coverTitle',
    'GLOBAL.mainProductsOrServices',
    'GLOBAL.strategyForAchievingGoals',
    'GLOBAL.targetMarket',
    'GLOBAL.targetAudience',
    'GLOBAL.targetChannels',
    'GLOBAL.mainCompetitors',
    'GLOBAL.mission',
    'EXECUTIVE_SUMMARY.companyDescription.history',
    'EXECUTIVE_SUMMARY.companyDescription.resourcesAndAssets',
    'EXECUTIVE_SUMMARY.productsOrServices.productsValue',
    'GLOBAL.competitionAdvantage',
    'GLOBAL.productDevelopmentPlans',
    'EXECUTIVE_SUMMARY.marketAndCustomers.dynamics',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
    'MARKET_ANALYSIS.marketOverview.mainMarketOverview',
    'MARKET_ANALYSIS.marketOverview.servicesProductsSummary',
    'MARKET_ANALYSIS.marketOverview.salesMethod',
    'MARKET_ANALYSIS.marketOverview.marketStructureDescription',
    'MARKET_ANALYSIS.marketOverview.marketGrowthFactors',
    'MARKET_ANALYSIS.marketOverview.priceStrategies',
    'MARKET_ANALYSIS.marketOverview.actualAndForecastedConsumption',
    'MARKET_ANALYSIS.competitiveAnalysis.competitors',
    'MARKET_ANALYSIS.competitiveAnalysis.barriers',
    'MARKET_ANALYSIS.consumerNeeds.purchasingDecision',
    'MARKET_ANALYSIS.consumerNeeds.howCustomersSatisfied',
    'MARKET_ANALYSIS.consumerNeeds.demand',
    'MARKET_ANALYSIS.consumerNeeds.customerBaseSize',
    'MARKETING_AND_SALES.salesPlan.goals',
    'MARKETING_AND_SALES.salesPlan.affectFactors',
    'MARKETING_AND_SALES.salesPlan.detailedSalesChannel',
    'MARKETING_AND_SALES.marketingPlan.advertisingCampaigns',
    'MARKETING_AND_SALES.marketingPlan.positioning',
    'MARKETING_AND_SALES.marketingPlan.pricingStrategy',
    'BUSINESS_OPERATIONS.locationAndPremises.location',
    'BUSINESS_OPERATIONS.locationAndPremises.futurePlans',
    'BUSINESS_OPERATIONS.equipment.description',
    'BUSINESS_OPERATIONS.otherAssets.description',
    'BUSINESS_OPERATIONS.technologicalProcess.technology',
    'BUSINESS_OPERATIONS.workingResources.necessaryRecourses',
    'BUSINESS_OPERATIONS.production.specifics',
    'PRODUCTS_AND_SERVICES.description.qualityStandards',
    'PRODUCTS_AND_SERVICES.description.productsOrServicesAndTheirPurpose',
    'PRODUCTS_AND_SERVICES.advantages.productValue',
    'MANAGEMENT_AND_ORGANIZATION.managementTeam.history',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.numberOfStaff',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.skills',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.additionalHires',
    'MANAGEMENT_AND_ORGANIZATION.staffOrganization.salaryPolicy',
    'RAISING_AND_ALLOCATING_FUNDS.investmentTotalCost',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDirectionDetails',
    'RAISING_AND_ALLOCATING_FUNDS.expectedFundingPeriod',
    'RAISING_AND_ALLOCATING_FUNDS.financedPortionDescription',
    'RAISING_AND_ALLOCATING_FUNDS.fundingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.raisingDescription',
    'RAISING_AND_ALLOCATING_FUNDS.terms',
    // complex fields
    'ABOUT_COMPANY.missionAndStrategy.goals',
    'ABOUT_COMPANY.swot',
    'MARKET_ANALYSIS.marketOverview.marketTrends',
    'MARKET_ANALYSIS.competitiveAnalysis.keyCompetitors',
    'MARKET_ANALYSIS.competitiveAnalysis.competitorsQualities',
    'MARKET_ANALYSIS.consumerNeeds.B2C',
    'MARKET_ANALYSIS.consumerNeeds.B2B',
    'MARKETING_AND_SALES.salesPlan.salesChannels',
    'GLOBAL.products',
    'FINANCIAL_PLAN.plannedExpenses.monthlyExpenses',
  ],
  [BUSINESS_PLAN_TYPES.ONE_PAGE]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.mainGoals',
    'GLOBAL.projectBriefDescription',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
    'GLOBAL.mainProductsOrServices',
    'GLOBAL.competitionAdvantage',
    'GLOBAL.targetMarket',
    'EXECUTIVE_SUMMARY.marketAndCustomers.dynamics',
    'GLOBAL.mainCompetitors',
    'GLOBAL.targetAudience',
    'GLOBAL.revenueStreams',
    'GLOBAL.marketingStrategy',
    'GLOBAL.targetChannels',
    'EXECUTIVE_SUMMARY.organizationAndTeam.members',
  ],

  [BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT]: [
    'GLOBAL.companyBriefDescription',
    'GLOBAL.projectBriefDescription',
    'ABOUT_COMPANY.missionAndStrategy.problemOfMarket',
    'ABOUT_COMPANY.missionAndStrategy.howProjectAddressesTheProblem',
    'GLOBAL.targetMarket',
    'GLOBAL.mainCompetitors',
    'GLOBAL.revenueStreams',
    'GLOBAL.marketingStrategy',
  ],
};
